/**
 * @generated SignedSource<<0c096b37f1e82cc4382ae1d03484687b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceSignalEditScheduledArchiveAtQuery$variables = {
  workspaceId: string;
  workspaceSignalId: string;
};
export type WorkspaceSignalEditScheduledArchiveAtQuery$data = {
  readonly workspace: {
    readonly signal: {
      readonly scheduledArchiveAt: {
        readonly isoString: string;
        readonly " $fragmentSpreads": FragmentRefs<"FormattedDate">;
      } | null;
    } | null;
  };
};
export type WorkspaceSignalEditScheduledArchiveAtQuery = {
  response: WorkspaceSignalEditScheduledArchiveAtQuery$data;
  variables: WorkspaceSignalEditScheduledArchiveAtQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "workspaceId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "workspaceSignalId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "workspaceId"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "workspaceSignalId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isoString",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkspaceSignalEditScheduledArchiveAtQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Workspace",
        "kind": "LinkedField",
        "name": "workspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "SignalWorkspace",
            "kind": "LinkedField",
            "name": "signal",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UnzonedDate",
                "kind": "LinkedField",
                "name": "scheduledArchiveAt",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "FormattedDate"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WorkspaceSignalEditScheduledArchiveAtQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Workspace",
        "kind": "LinkedField",
        "name": "workspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "SignalWorkspace",
            "kind": "LinkedField",
            "name": "signal",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UnzonedDate",
                "kind": "LinkedField",
                "name": "scheduledArchiveAt",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isDate"
                  }
                ],
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e823dc068d83db7acf0e9b51bb7ae980",
    "id": null,
    "metadata": {},
    "name": "WorkspaceSignalEditScheduledArchiveAtQuery",
    "operationKind": "query",
    "text": "query WorkspaceSignalEditScheduledArchiveAtQuery(\n  $workspaceId: ID!\n  $workspaceSignalId: ID!\n) {\n  workspace(id: $workspaceId) {\n    signal(id: $workspaceSignalId) {\n      scheduledArchiveAt {\n        isoString\n        ...FormattedDate\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment FormattedDate on Date {\n  __isDate: __typename\n  ...useFormattedDate\n}\n\nfragment useFormattedDate on Date {\n  __isDate: __typename\n  isoString\n}\n"
  }
};
})();

(node as any).hash = "3d2890cb347acb8b1a776d0c76f5f0ac";

export default node;
